// extracted by mini-css-extract-plugin
export default {"cls1":"FreeformQuestion-cls1_hMo","cls2":"FreeformQuestion-cls2_vtM FreeformQuestion-cls1_hMo"};